/** The three 24x7 channels (central channel_id values). Both the admin
 * scheduler and the /na-24x7 guide read this; a live-channel flag on the
 * central channel record will replace it once it exists. */
export const LIVE_CHANNEL_IDS = [9, 10, 11];

/** NA 24x7 is a NAHL channel: only the nahl tenant and its dev/staging
 * counterpart (STAGE_DB is a NAHL clone) get the /na-24x7 guide and the
 * admin Scheduler. Every route, nav item and admin tab for either checks
 * this one list, so the two cannot drift apart. */
export const LIVE_CHANNEL_TENANTS = ["nahl", "dev"];

export function isLiveChannelTenant(tenantName: string | undefined | null): boolean {
  return LIVE_CHANNEL_TENANTS.includes(tenantName ?? "");
}
